export class Constants {
  public static CONVENIO_MULTILARETAL: string = "4";
  public static INSCRIPTO: string = "3";
  public static EXENTO: string = "2";
  public static NO_INCRIPTO: string = "1";
  public static REGIMEN_SIMPLIFICADO = "5";
}

export class MultilateralAgreement {
  public static SYSTEM_PADRON_WEB: string = "Constancia de sistema padron web";
  public static CM05: string = "CM05";
}

export class DocumentId {
  public static ACTA: number = 2;
  public static ESTATUTO: number = 3;
  public static IMPUESTO_CONTRATO_LOCATION: number = 6;
  public static EXENTO_RESOLUCION: number = 7;
  public static CONSTANCIA_IIBB: number = 8;
  public static IIBB_CM05: number = 9;
  public static IIBB_CONSTANCIA_PADRON: number = 10;
  public static REBA: number = 11;
  public static FOTO_COMERCIO: number = 12;
  public static IIBB_ACUSE_RECIBO: number = 13;
  public static CONSTANCIA_CUIL: number = 14;
  public static CI_FRENTE: number = 21;
  public static CI_DORSO: number = 22;
  public static CEDULA_TRIBUTARIA = 23;
  public static CI_FRENTE_PRESIDENTE: number = 24;
  public static CI_DORSO_PRESIDENTE: number = 25;
  public static CEDULA_REPRESENTANTE: number = 26;
  public static DOCUMENTO_PODER: number = 27;
  public static CEDULA_APODERADO_RESIDENTE: number = 31;
}

export class DocName {
  public static ACTA: string = "Acta vigente de la sociedad.";
  public static ESTATUTO: string = "Estatuto de la sociedad.";
  public static CEDULA_TRIBUTARIA = "Cédula tributaria.";
  public static CI_FRENTE_PRESIDENTE: string = "Frente CI del presidente.";
  public static CI_DORSO_PRESIDENTE: string = "Dorso CI del presidente.";
  public static CEDULA_REPRESENTANTE: string = "Cédula de representante o operadora.";
  public static DOCUMENTO_PODER: string = "Documento del poder (opcional).";
  public static CEDULA_APODERADO_RESIDENTE: string = "Cedula del Apoderado o Residente (opcional).";
}

export class CreateFile {
  public static ONE_FILE: boolean = true;
}

export enum IibbCategory {
  NoInscripto = 1,
  Exento = 2,
  InscriptoLocal = 3,
  ConvenioMultilateral = 4,
  RegimenSimplificado = 5,
}

export class DocKey {
  public static DNI_FRENTE: string = "DniFrenteSolicitante";
  public static DNI_ATRAS: string = "DniAtrasSolicitante";
  public static DNI_P_FRENTE: string = "DniPreAtrasSolicitante";
  public static DNI_P_ATRAS: string = "DniPreAtrasSolicitante";
  public static DNI_O_FRENTE: string = "DniFrenteOtherSolicitante";
  public static DNI_O_ATRAS: string = "DniAtrasOtherSolicitante";
  public static ACTA: string = "Acta";
  public static ESTATUTO: string = "Estatuto";
  public static IMPUESTO_CONTRATO_LOCATION: string = "ImpuestoContratoLocation";
  public static EXENTO_RESOLUCION: string = "ExentoResolucion";
  public static CONSTANCIA_IIBB: string = "ConstanciaIIBB";
  public static IIBB_CM05: string = "IIBBCm05";
  public static IIBB_CONSTANCIA_PADRON: string = "IIBBContanciaPadron";
  public static REBA: string = "Reba";
  public static FOTO_COMERCIO: number = 12;
  public static IIBB_ACUSE_RECIBO: string = "IIBBAcuseRecibo";
  public static CONSTANCIA_CUIL: string = "ConstanciaCuil";
  public static CI_FRENTE: string = "CIFrente";
  public static CI_DORSO: string = "CIDorso";
  public static CEDULA_TRIBUTARIA: string = "CedulaTributaria";
  public static CI_FRENTE_PRESIDENTE: string = "CIFrentePresidente";
  public static CI_DORSO_PRESIDENTE: string = "CIDorsoPresidente";
  public static CEDULA_REPRESENTANTE: string = "CedulaRepresentante";
  public static DOCUMENTO_PODER: string = "DocPoder";
  public static CEDULA_APODERADO_RESIDENTE = "CedulaApoderado";
}

export const NameFileRegex = /^[a-zA-Z0-9_\-() .]+$/;
